import { convertReactAdminIdToHydraId } from 'utils';
export const getIdFilterDefaultValue = (id: number | null, entity: string): string | null => {
  return id ? convertReactAdminIdToHydraId(id, entity) : null;
};
